export type AppMode = 'social' | 'colleges' | 'main';

export function getAppMode(): AppMode {
  const hostname = window.location.hostname;
  
  // Local dev override via query param: ?app=social
  const params = new URLSearchParams(window.location.search);
  const override = params.get('app');
  if (override === 'social') return 'social';
  if (override === 'colleges') return 'colleges';
  
  // Production subdomain detection
  if (hostname.startsWith('social.')) return 'social';
  if (hostname.startsWith('colleges.')) return 'colleges';
  
  return 'main';
}
